<template>
  <v-app id="login-page">
    <v-main class="login-container">
      <div class="bg-image"></div>
      <div class="bg-overlay"></div>

      <div class="top-bar">
        <div class="brand-mini d-flex align-center">
          <v-avatar size="40" color="white" class="mr-2 logo-avatar">
            <v-img src="/images/logo.png" contain max-height="26" max-width="26" />
          </v-avatar>
          <div class="brand-mini-text">
            <span class="brand-mini-title">Bondowoso</span>
            <span class="brand-mini-title accent-word">Berkah</span>
          </div>
        </div>

      </div>

      <div class="left-panel d-none d-md-flex">
        <div class="left-panel-content">
          <h1 class="hero-title">
            BONDOWOSO<br />
            <span class="accent-word">BERKAH</span>
          </h1>

          <p class="hero-subtitle">Berkualitas, Akseleratif, Holistik</p>

          <p class="hero-desc">Sistem digitalisasi Kabupaten Bondowoso.</p>

          <div class="feature-list">
            <div class="feature-item" v-for="(f, i) in features" :key="i">
              <div class="feature-icon">
                <v-icon color="white" size="18">{{ f.icon }}</v-icon>
              </div>
              <div>
                <div class="feature-title">{{ f.title }}</div>
                <div class="feature-desc">{{ f.desc }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="location-badge">
          <v-icon color="#CFA22D" size="20" class="mr-2">mdi-map-marker</v-icon>
          <div>
            <div class="location-title">Kabupaten Bondowoso</div>
            <div class="location-sub">Jawa Timur, Indonesia</div>
          </div>
        </div>
      </div>

      <v-container class="fill-height relative-content" fluid>
        <v-row align="center" justify="center" class="fill-height">
          <v-col cols="12" class="login-wrapper">
            <v-card class="login-card pa-8 rounded-xl" elevation="0">
              <div class="text-center mb-6">
                <v-avatar size="52" color="#EAF6F3" class="mb-3">
                  <v-img src="/images/logo.png" contain max-height="30" max-width="30" />
                </v-avatar>
                <div class="brand-title">
                  <span>Bondowoso</span>
                  <span class="accent-word-dark">Berkah</span>
                </div>
                <h2 class="form-title">Selamat Datang</h2>
                <p class="form-subtitle">Silahkan login untuk melanjutkan</p>
              </div>

              <v-form @submit.prevent="handleLogin">
                <v-text-field
                  v-model="username"
                  label="Username atau Email"
                  prepend-inner-icon="mdi-account-outline"
                  outlined
                  dense
                  color="#018C74"
                  class="custom-field mb-1"
                />

                <v-text-field
                  v-model="password"
                  label="Password"
                  prepend-inner-icon="mdi-lock-outline"
                  :type="show ? 'text' : 'password'"
                  :append-icon="show ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  @click:append="show = !show"
                  outlined
                  dense
                  color="#018C74"
                  class="custom-field mb-1"
                />

                <div class="d-flex align-center justify-space-between mb-4 remember-row">
                  <v-checkbox
                    v-model="rememberMe"
                    label="Ingat saya"
                    color="#018C74"
                    dense
                    hide-details
                    class="mt-0"
                  />
                  <a href="#" class="forgot-link">Lupa password?</a>
                </div>

                <div id="g-recaptcha" class="captcha-container mb-4"></div>

                <v-fade-transition>
                  <v-alert
                    v-if="error"
                    dense
                    dismissible
                    type="error"
                    class="text-caption rounded-lg mb-4"
                  >
                    Akses ditolak. Periksa kembali akun Anda.
                  </v-alert>
                </v-fade-transition>

                <v-btn
                  type="submit"
                  block
                  height="50"
                  class="login-btn"
                  :loading="loading"
                  :disabled="!captchaVerified"
                >
                  <v-icon left size="18">
                    {{
                      captchaVerified
                        ? "mdi-lock-check-outline"
                        : "mdi-shield-lock-outline"
                    }}
                  </v-icon>
                  <span>{{ captchaVerified ? "MASUK" : "VERIFIKASI" }}</span>
                </v-btn>

              </v-form>

              <div class="text-center mt-6 secure-note">
                <v-icon size="14" color="#018C74" class="mr-1"
                  >mdi-shield-check-outline</v-icon
                >
                ©2026 Dinas Komunikasi dan Informatika
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <div class="page-footer">
        <span>© {{ currentYear }} Bondowoso Berkah. All rights reserved.</span>
        <div class="d-flex align-center">
          <span class="mr-4">Manajemen Sistem v2.0.0</span>
          <span class="secure-chip">
            <v-icon size="12" class="mr-1">mdi-shield-check</v-icon>
            Terenkripsi
          </span>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    username: "",
    password: "",
    error: false,
    show: false,
    loading: false,
    rememberMe: true,
    captchaVerified: false,
    widgetId: null,
    currentYear: new Date().getFullYear(),
    features: [
      {
        icon: "mdi-shield-check-outline",
        title: "Aman & Terpercaya",
        desc: "Sistem dilengkapi keamanan berlapis",
      },
      {
        icon: "mdi-layers-outline",
        title: "Terintegrasi",
        desc: "Seluruh data dalam satu platform",
      },
      {
        icon: "mdi-chart-line",
        title: "Realtime",
        desc: "Data selalu update dan akurat",
      },
    ],
  }),
  mounted() {
    this.initCaptcha();
  },
  methods: {
    initCaptcha() {
      const checkGrecaptcha = setInterval(() => {
        if (typeof window.grecaptcha !== "undefined" && window.grecaptcha.render) {
          clearInterval(checkGrecaptcha);

          window.grecaptcha.render("g-recaptcha", {
            sitekey: "6Lepj1IsAAAAAB-2w3plY3b8KDry863j0x0yXwSb",
            theme: "light",
            callback: (response) => {
              this.captchaVerified = true;
            },
            "expired-callback": () => {
              this.captchaVerified = false;
            },
          });
        }
      }, 500);
    },
    googleLogin() {
    },
    async handleLogin() {
      if (!this.captchaVerified) return;
      this.loading = true;
      this.error = false;

      try {
        const response = await fetch("https://berkah.bondowosokab.go.id:5500/login", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Bondowoso-Berkah":
              "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97",
          },
          body: JSON.stringify({
            username: this.username,
            password: this.password,
          }),
        });

        const result = await response.json();

        if (result.metadata.code === 200) {
          localStorage.setItem("isLoggedIn", "true");

          localStorage.setItem("userData", JSON.stringify(result.response.data.user));
          localStorage.setItem("userRole", JSON.stringify(result.response.data.role));
          localStorage.setItem("userMenus", JSON.stringify(result.response.data.menus));

          this.$router.push("/pages/dashboard");
        } else {
          this.error = true;
          this.errorMessage = result.metadata.message;
        }
      } catch (err) {
        console.error("Login Error:", err);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #012620;
}

.bg-image {
  position: absolute;
  inset: 0;
  background: url("/images/gambarlogin.png") center center no-repeat,
    linear-gradient(120deg, #013b31 0%, #0a5c4c 55%, #0f7a63 100%);
  background-size: cover;
  z-index: 0;
}

.bg-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(0, 20, 16, 0.75) 0%,
    rgba(0, 20, 16, 0.35) 45%,
    rgba(0, 20, 16, 0.15) 100%
  );
  z-index: 1;
}

.relative-content {
  position: relative;
  z-index: 3;
}

.top-bar {
  position: absolute;
  top: 28px;
  left: 40px;
  right: 40px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-avatar {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}

.brand-mini-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.brand-mini-title {
  color: white;
  font-weight: 800;
  font-size: 1rem;
}

.accent-word {
  color: #2fd6b3;
}

.help-btn {
  text-transform: none;
  border-color: rgba(255, 255, 255, 0.5) !important;
  letter-spacing: 0;
}

.left-panel {
  position: absolute;
  left: 40px;
  top: 0;
  bottom: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 480px;
}

.hero-title {
  color: white;
  font-weight: 900;
  font-size: 3rem;
  letter-spacing: 4px;
  line-height: 1.1;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.hero-subtitle {
  color: #2fd6b3;
  font-weight: 600;
  letter-spacing: 3px;
  margin-top: 14px;
  margin-bottom: 4px;
  font-size: 0.95rem;
}

.hero-desc {
  color: rgba(255, 255, 255, 0.75);
  max-width: 380px;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 32px;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 14px;
}

.feature-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  background: rgba(47, 214, 179, 0.18);
  border: 1px solid rgba(47, 214, 179, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-title {
  color: white;
  font-weight: 700;
  font-size: 0.9rem;
}

.feature-desc {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.78rem;
}

.location-badge {
  position: absolute;
  bottom: 56px;
  left: 0;
  display: flex;
  align-items: center;
  background: rgba(0, 20, 16, 0.55);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  padding: 12px 18px;
}

.location-title {
  color: white;
  font-weight: 700;
  font-size: 0.85rem;
}

.location-sub {
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.72rem;
}

.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-card {
  width: 100%;
  max-width: 450px;
}

.brand-title {
  font-weight: 800;
  font-size: 1.05rem;
  color: #013b31;
  letter-spacing: 0.5px;
}

.accent-word-dark {
  color: #018c74;
  margin-left: 4px;
}

.form-title {
  color: #012620;
  font-weight: 800;
  margin-top: 10px;
  font-size: 1.4rem;
}

.form-subtitle {
  color: #6b7b78;
  font-size: 0.85rem;
  margin-top: 2px;
}

.remember-row {
  margin-top: -8px;
}

.forgot-link {
  color: #018c74;
  font-size: 0.82rem;
  text-decoration: none;
  font-weight: 600;
}

.captcha-container {
  display: flex;
  justify-content: center;
  min-height: 78px;
}

#g-recaptcha {
  transform: scale(0.9);
  transform-origin: center;
}

.login-btn {
  background: linear-gradient(90deg, #018c74, #02b395) !important;
  color: white !important;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0.3px;
  border-radius: 10px !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.35) !important;
}

.divider-row {
  display: flex;
  align-items: center;
  text-align: center;
  color: #9aa6a3;
  font-size: 0.8rem;
}

.divider-row::before,
.divider-row::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #e3e8e7;
}

.divider-row span {
  padding: 0 12px;
}

.google-btn {
  text-transform: none;
  border-color: #e3e8e7 !important;
  color: #333 !important;
  font-weight: 600;
  border-radius: 10px !important;
}

.secure-note {
  color: #8a9794;
  font-size: 0.75rem;
}

.page-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 40px;
  background: rgba(0, 15, 12, 0.55);
  backdrop-filter: blur(6px);
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.75rem;
}

.secure-chip {
  display: inline-flex;
  align-items: center;
  background: rgba(47, 214, 179, 0.15);
  border: 1px solid rgba(47, 214, 179, 0.4);
  color: #2fd6b3;
  padding: 2px 10px;
  border-radius: 20px;
  font-weight: 600;
}

@media (max-width: 960px) {
  .top-bar {
    left: 20px;
    right: 20px;
  }
  .page-footer {
    padding: 12px 20px;
    flex-direction: column;
    gap: 6px;
    text-align: center;
  }
}
</style>
